/**
 * Whether a scrolling pane should keep itself pinned to its newest content.
 *
 * The conversation arrives while the learner is reading it, and the two wants
 * conflict: a transcript that does not follow leaves the tutor talking below
 * the fold, and one that always follows yanks the view away from someone who
 * scrolled back to re-read a line. Following only from the bottom settles it —
 * the learner opts out by scrolling up, and opts back in by scrolling down.
 *
 * Geometry rather than a `scroll` listener, because the question is asked after
 * React has committed a new line: what matters is where the pane was left, not
 * how it got there.
 */
export function follows({
  scrollTop,
  scrollHeight,
  clientHeight,
}: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}): boolean {
  // Fractional layout — a bubble whose height lands on 41.6px — leaves this
  // distance a hair above zero at what the learner sees as the bottom. Without
  // the slack the pane stops following the moment a line of that height
  // arrives, which is every line. Two pixels covers the rounding and nothing a
  // learner could have deliberately scrolled to.
  return scrollHeight - (scrollTop + clientHeight) <= 2;
}
